module.exports = __webpack_public_path__ + "img/offer-money-out.eda1311d.svg";